var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { List, ListItem, Stack } from "@mui/material";
// constants
import { COLORS } from "../../../../../../constants";
// components
import { ButtonV2, Text } from "../../../../../Atoms";
import { Context } from "../../../context";
/**
 * Displays a list of broker/partners provided
 */
var BrokerPreviewList = function (_a) {
    var brokerList = _a.brokerList, onClick = _a.onClick, logo = _a.logo, headerText = _a.headerText, headerText2 = _a.headerText2, ctaText = _a.ctaText, type = _a.type;
    var hasShadow = useContext(Context).hasShadow;
    return (_jsxs(Stack, __assign({ border: hasShadow
            ? [undefined, "1px solid ".concat(COLORS.P_OUTLINE)]
            : "1px solid ".concat(COLORS.P_OUTLINE), "data-testid": "preview-brokers-".concat(type), width: "100%", borderRadius: 2, px: 2, py: 4, mb: 4, alignItems: "center" }, { children: [logo, _jsxs(Text, __assign({ variant: "body1", sx: { mt: 4 }, align: "center" }, { children: [headerText, _jsx("br", {}), headerText2] })), _jsx(List, __assign({ sx: {
                    listStyleType: "disc",
                    columns: 2,
                    ml: 2,
                    mb: 4,
                    width: "100%",
                    pr: 1.75,
                    maxWidth: 324,
                } }, { children: brokerList.map(function (broker) { return (_jsx(ListItem, __assign({ "data-testid": "broker-".concat(broker), sx: {
                        display: "list-item",
                        ml: 3,
                        pl: 0,
                        pr: 0,
                        pb: 0,
                    } }, { children: _jsx(Text, __assign({ variant: "body1" }, { children: broker })) }), broker)); }) })), _jsx(ButtonV2, __assign({ onClick: onClick, "data-testid": "button-".concat(type, "-flow"), sx: { width: "100%" } }, { children: ctaText }))] })));
};
export default React.memo(BrokerPreviewList);
